import React from "react";
import { ConfigSection } from "../ConfigSection";
import { StyledTextField } from "../StyledTextField";
import { validateMinimumShouldMatch } from "../../utils/validation";
import { BooleanQueryConfigSectionProps } from "../../types";

export const BooleanQueryConfigSection: React.FC<
  BooleanQueryConfigSectionProps
> = ({ config, updateMinimumShouldMatch }) => (
  <ConfigSection
    title="Boolean Query Configuration"
    tooltip="This controls how many of your search terms need to be found for a result to be shown. For example, if you search for 'red apple fruit' and set this to 2, then a result needs to contain at least 2 of those words to appear in your search results. Setting it to 1 means finding just one word is enough, while setting it to 3 means all words must be found."
  >
    <StyledTextField
      fullWidth
      label="Minimum Should Match"
      type="number"
      inputProps={{ min: 1, max: 50 }}
      value={config.minimumShouldMatch ?? ""}
      validate={validateMinimumShouldMatch}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (value !== "") {
          const numValue = parseInt(value);
          if (!isNaN(numValue)) {
            updateMinimumShouldMatch(numValue);
          }
        }
      }}
      helperText="Minimum number of query signals that must match. Range: 1–50."
    />
  </ConfigSection>
);
